var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/iconButton.scss';
import React, { forwardRef } from 'react';
import { IconButtonType, IconButtonTypeClass, SelectedIconButtonTypeClass } from './IconButtonTypes.interface';
import { SvgIcon } from '../SvgIcon/SvgIcon';
export const IconButton = forwardRef((_a, ref) => {
    var { icon, mode = IconButtonType.PanelTool, disabled = false, selected = false, className, onClick } = _a, restProps = __rest(_a, ["icon", "mode", "disabled", "selected", "className", "onClick"]);
    const iconButtonClassNames = [
        'icon-button',
        className,
        selected ? SelectedIconButtonTypeClass[mode] : IconButtonTypeClass[mode]
    ];
    const iconButtonClassName = iconButtonClassNames.filter(Boolean).join(' ');
    const iconElement = React.isValidElement(icon) ? icon : _jsx(SvgIcon, { icon: icon });
    return (_jsx("button", Object.assign({ ref: ref, className: iconButtonClassName, onClick: onClick, disabled: disabled }, restProps, { children: iconElement })));
});
